exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader {width: 100%;height: 100%; z-index: 9999; background: rgba(255,255,255,0.6); position: fixed; top:0; left: 0; float: left;}\n.loader .mat-spinner{left:50%; top:50%; position: absolute; width: 50px; height: 50px;}\n.loader .mat-spinner.mat-primary path{stroke:#2196F3; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = 39